import React, { Component } from "react";
import { AsyncStorage } from "react-native";
import {
	View,
	StyleSheet,
	KeyboardAvoidingView,
	TextInput,
	Alert,
	Platform,
	Image,
	TouchableOpacity,
	Linking,
	Switch,
} from "react-native";
import { NavigationActions } from "react-navigation";
import { translate } from "react-i18next";

import AWS from "aws-sdk/dist/aws-sdk-react-native";
import { CognitoUserAttribute } from "amazon-cognito-identity-js";

import { push, reset } from "utils/navigation";
import { STATES, COUNTRY } from "utils/config";
import { signUp, login, updateUser } from "utils/awsAuth";
import { TextField } from "components/third-party/Textfield";
import ViewScroll from "components/ViewScroll";
import BackgroundImage from "components/BackgroundImage";
import Text from "components/StyledText";
import validation from "utils/validation";
import Checkbox from "components/Checkbox";
import Header from "components/Header";
import Button from "components/Button";
import Textfield from "components/Textfield";
import Select from "components/Select";

import * as x from "../../../styles/css";

class UserDetail extends Component {
	static navigationOptions = {
		header: null,
	};

	static isPrivate = true;

	constructor(props) {
		super(props);

		this.state = {
			inputs: {
				email: "",
				name: "",
				phone_number: "",
				address: "",
				addressLine2: "",
				suburb: "",
				postcode: "",
				state: "",
				password: "",
				country: "",
				confirmPassword: "",
				dialingCode: "",
				signupForNews: false,
			},
			error: {
				email: "",
				name: "",
				address: "",
				addressLine2: "",
				phone_number: "",
				suburb: "",
				postcode: "",
				state: "",
				password: "",
				confirmPassword: "",
				country: "",
				dialingCode: "",
			},
			loading: false,
		};

		this.dialingCodeExists = this.dialingCodeExists.bind(this);
		this.separatePhoneToDialing = this.separatePhoneToDialing.bind(this);
		this.getDataToFormMobile = this.getDataToFormMobile.bind(this);
		this.handleUpdate = this.handleUpdate.bind(this);
	}

	separatePhoneToDialing(phone_number) {
		let result = {};
		COUNTRY.forEach(function(item){
			if(phone_number.indexOf(item.dial_code, 1) === 1) {
				result = {
					dialingCode: item.dial_code,
					phone_number: phone_number.substr(item.dial_code.length+1)
				}
			}
		});
		return result;
	}

	getDataToFormMobile(stores) {
		let userData = [];
		stores.forEach(function(item){
			switch (item[0]) {
				case "phone_number":
					userData.phone_number = item[1];
					break;
				case "email":
					userData.email = item[1];
					break;
				case "name":
					userData.name = item[1];
					break;
				case "custom:address_line_one":
					userData.address = item[1];
					break;
				case "custom:address_line_two":
					userData.addressLine2 = item[1];
					break;
				case "custom:suburb":
					userData.suburb = item[1];
					break;
				case "custom:postcode":
					userData.postcode = item[1];
					break;
				case "custom:state":
					userData.state = item[1];
					break;
				case "custom:country":
					userData.country = item[1];
					break;
				case "custom:signupForNews":
					userData.signupForNews = (item[1] === "0") ? false : true;
					break;
				default:
					break;
			}
		});
		return userData;
	}

	componentDidMount() {
		let userData = [];
		if(Platform.OS !== "web"){
			// should load using react-native memory
			let stores = [];
			AsyncStorage.getAllKeys((err, keys) => {
				AsyncStorage.multiGet(keys, (err, stores) => {
					userData = this.getDataToFormMobile(stores);
					console.log(userData);
					let resultSeparate = this.separatePhoneToDialing(userData.phone_number);


					this.setState({
						inputs: {
							email: userData.email,
							name: userData.name,
							dialingCode: resultSeparate.dialingCode,
							phone_number: resultSeparate.phone_number,
							address: userData.address,
							addressLine2: userData.addressLine2,
							suburb: userData.suburb,
							postcode: userData.postcode,
							country: userData.country,
							state: userData.state,
							signupForNews: userData.signupForNews,
						}
					}, ()=>{
						this.setState({
							areastate: AsyncStorage.getItem("custom:state")
						});
						console.log(this.state.inputs);
					});
				});
			});
		} else {
			const phoneToCheck = localStorage.getItem("phone_number");
			let resultSeparate = this.separatePhoneToDialing(phoneToCheck);
			console.log(resultSeparate);

			// load from localStorage
			this.setState({
				inputs: {
					email: localStorage.getItem("email"),
					name: localStorage.getItem("name"),
					dialingCode: resultSeparate.dialingCode,
					phone_number: resultSeparate.phone_number,
					address: localStorage.getItem("custom:address_line_one"),
					addressLine2: localStorage.getItem("custom:address_line_two"),
					suburb: localStorage.getItem("custom:suburb"),
					postcode: localStorage.getItem("custom:postcode"),
					country: localStorage.getItem("custom:country"),
					state: localStorage.getItem("custom:state"),
					signupForNews: localStorage.getItem("custom:signupForNews"),
				}
			}, ()=>{
				this.setState({
					areastate: localStorage.getItem("custom:state")
				});
				console.log(this.state.inputs);
			});

		}
	}

	/*componentDidUpdate(prevProps, prevState) {
		if (prevState.inputs.country !== this.state.inputs.country) {
			this.setState({
				inputs: {
					...this.state.inputs,
					dialingCode: COUNTRY.find("Australia"
					).dial_code,
					state: "",
				},
			});
		}
	}*/

	async handleUpdate() {
		const { areastate } = this.state;
		const inputs = {
			...this.state.inputs,
		};

		if (inputs.phone_number) {
			inputs.phone_number = `+${inputs.dialingCode}${
				inputs.phone_number
			}`;
		}

		let userData = {
			name: inputs.name,
			phone_number: inputs.phone_number,
			"custom:address_line_one": inputs.address,
			"custom:address_line_two": inputs.addressLine2,
			"custom:suburb": inputs.suburb,
			"custom:postcode": inputs.postcode,
			"custom:state": areastate,
			"custom:signupForNews": inputs.signupForNews ? "1" : "0",
			"custom:country": inputs.country,
		}

		let result = await updateUser(userData);

		if (result){
			push({ mobile: "Home", web: "/" }, this.props, true);
		}
	}

	dialingCodeExists(code) {
		return !!COUNTRY.find(item => item.dial_code === code);
	}

	goBack() {
		push({ mobile: "Home", web: "/" }, this.props, true);
	}

	render() {
		const { areastate, inputs, error } = this.state;

		const { t } = this.props;

		return (
			<ViewScroll>
				<View style={[x.mb.three]}>
					<Header>{t("labels.account")}</Header>
				</View>
				<View style={[x.my.three]}>
					<Textfield
						label={t("labels.email")}
						value={inputs.email}
						error={error.email}
						onChangeText={email =>
							this.setState({
								inputs: { ...inputs, email },
							})
						}
						isEditable={false}
						style={{backgroundColor: "grey"}}
						keyboardType="email-address"
					/>
					<Textfield
						label={t("labels.name")}
						value={inputs.name}
						error={error.name}
						onChangeText={name =>
							this.setState({
								inputs: { ...inputs, name },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						label={t("labels.address")}
						value={inputs.address}
						error={error.address}
						onChangeText={address =>
							this.setState({
								inputs: { ...inputs, address },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						value={inputs.addressLine2}
						label={t("labels.addressLine2")}
						error={error.addressLine2}
						onChangeText={addressLine2 =>
							this.setState({
								inputs: { ...inputs, addressLine2 },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						value={inputs.suburb}
						label={t("labels.suburb")}
						error={error.suburb}
						onChangeText={suburb =>
							this.setState({
								inputs: { ...inputs, suburb },
							})
						}
						keyboardType="default"
					/>
					<View style={[x.d.flex]}>
						<Select
							native
							label={t("labels.country")}
							onChange={country =>
								this.setState({
									inputs: {
										...inputs,
										country: country.target.value,
									},
								})
							}
							onChangeText={country =>
								this.setState({
									inputs: {
										...inputs,
										country,
									},
								})
							}
							value={inputs.country}
							error={error.country}
							data={COUNTRY.map(item => item.name)}
						/>
					</View>
					<View
						style={[
							x.flexDirection.row,
							x.justifyContent.flexStart,
						]}
					>
						<View style={{ flex: 1 }}>
							<Textfield
								label={t("labels.postcode")}
								value={inputs.postcode}
								error={error.postcode}
								onChangeText={postcode =>
									this.setState({
										inputs: {
											...inputs,
											postcode,
										},
									})
								}
								keyboardType="numeric"
							/>
						</View>
						<View style={[x.d.flex, styles.state]}>
							{inputs.country &&
							inputs.country.toLowerCase() === "australia" ? (
								<Select
									native
									label={t("labels.state")}
									onChange={state =>
										this.setState({
											inputs: {
												...inputs,
												state: state.target.value,
											},
										})
									}
									onChangeText={state =>
										this.setState({
											inputs: {
												...inputs,
												state,
											},
										})
									}
									value={areastate}
									error={error.state}
									data={STATES}
								/>
							) : (
								<Textfield
									label={t("labels.state")}
									value={inputs.state}
									error={error.state}
									onChangeText={state =>
										this.setState({
											inputs: {
												...inputs,
												state,
											},
										})
									}
									keyboardType="default"
								/>
							)}
						</View>
					</View>
					<View style={[x.flexDirection.row]}>
						<View
							style={[
								Platform.OS !== "web" ? x.d.flex : {},
								x.mr.two,
							]}
						>
							<Textfield
								label={t("labels.dialingCode")}
								flag={
									this.dialingCodeExists(inputs.dialingCode)
										? COUNTRY.find(
												item =>
													item.dial_code ===
													inputs.dialingCode
										  ).flag
										: "🚫"
								}
								value={inputs.dialingCode}
								error={error.dialingCode}
								onChangeText={dialingCode =>
									this.setState({
										inputs: {
											...inputs,
											dialingCode,
										},
									})
								}
								keyboardType="numeric"
							/>
						</View>
						<Textfield
							label={t("labels.phone_number")}
							containerStyle={[
								Platform.OS === "web" ? x.d.flex : x.d.flex3,
							]}
							value={inputs.phone_number}
							error={error.phone_number}
							onChangeText={phone_number =>
								this.setState({
									inputs: { ...inputs, phone_number },
								})
							}
							keyboardType="numeric"
						/>
					</View>
					{/* <Textfield
						value={inputs.password}
						label={t("labels.password")}
						secureTextEntry
						autoCapitalize="none"
						error={error.password}
						title="Minimum 6 characters"
						onChangeText={password =>
							this.setState({
								inputs: { ...inputs, password },
							})
						}
						keyboardType="default"
					/>
					<Textfield
						value={inputs.confirmPassword}
						label={t("labels.confirmPassword")}
						secureTextEntry
						autoCapitalize="none"
						error={error.confirmPassword}
						onChangeText={confirmPassword =>
							this.setState({
								inputs: { ...inputs, confirmPassword },
							})
						}
						keyboardType="default"
					/> */}
					<View style={[x.mb.two]}>
						<Checkbox
							label={t("labels.signUpNews")}
							value={inputs.signupForNews}
							onValueChange={value =>
								this.setState({
									inputs: { ...inputs, signupForNews: value },
								})
							}
						/>
					</View>
				</View>
				<View style={[x.mt.one]}>
					<Button
						disabled={this.state.loading}
						onPress={this.handleUpdate}
						title={t("labels.edit")}
						color={x.colors.default}
					/>
					<Button
						disabled={this.state.loading}
						onPress={() => this.goBack()}
						title={t("labels.cancel")}
						color={"#A1D9DA"}
					/>
				</View>
			</ViewScroll>
		);
	}
}

const styles = StyleSheet.create({
	body: {
		backgroundColor: "white",
	},
	appHeader: {
		padding: 20,
		height: 100,
	},
	appTitle: {
		fontSize: 16,
		color: "white",
	},
	appIntro: {
		flex: 2,
		fontSize: 30,
		textAlign: "center",
	},
	loginBody: {
		marginTop: 40,
	},
	scrollView: {
		marginBottom: 20,
		marginTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		backgroundColor: "white",
	},
	state: {
		paddingLeft: 20,
	},
	background: {
		backgroundColor: "#fff",
		...(Platform.OS === "web"
			? { maxHeight: 600, minHeight: 500, width: "100%" }
			: {}),
	},
	spinnerTextStyle: {
		color: '#FFF'
	},
});

export default translate()(UserDetail);



// WEBPACK FOOTER //
// ./src/views/UserAuth/UserDetail/index.js